import React from 'react';
import { formatString } from '../../Common/CommonVariables';
import { useTranslation } from 'react-i18next';

const Gender = ({ nextStep, prevStep, handleChange, formData,error,step, totalSteps, isHighmarkPortal }) => {
  // const isNextEnabled = !!formData.assignedSex;
  const { t, i18n } = useTranslation();

  return (
    <>
      <div>
        <h3 className="page-heading-secondary-black-500 mb-5">{t('assignedsex')}</h3>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="assignedSex"
            id="assignedSex1"
            value="Female"
            checked={formatString(formData.assignedSex) === 'female'}
            onChange={handleChange}
          />
          <label for="assignedSex1" className="multistep-form-radio-checkbox-label">{t('fmal')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="assignedSex"
            id="assignedSex2"
            value="Male"
            checked={formatString(formData.assignedSex) === 'male'}
            onChange={handleChange}
          />
          <label for="assignedSex2" className="multistep-form-radio-checkbox-label">{t('male')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="assignedSex"
            id="assignedSex3"
            value="Intersex"
            checked={formatString(formData.assignedSex) === 'intersex'}
            onChange={handleChange}
          />
          <label for="assignedSex3" className="multistep-form-radio-checkbox-label">{t('intersex')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="assignedSex"
            id="assignedSex4"
            value="Prefer not to say"
            checked={formatString(formData.assignedSex) === 'prefernottosay'}
            onChange={handleChange}
          />
          <label for="assignedSex4" className="multistep-form-radio-checkbox-label">{t('prefertosay')}</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        <div className="mt-5">
          {/* <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
            {t('back')}
          </button> */}
          {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={nextStep}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>{t('back')}</button>
            <button className="win-btn-primary mobile-view" onClick={nextStep}>{t('next')}</button>
          </div>
        )}
        </div>
      </div>
    </>
  );
};

export default Gender;
